
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["vuex_config"]),
  },
  data() {
    return {};
  },
  async asyncData({ app, query, params }) {
    let key = query.key ? query.key : "privacy_explain";
    let title = '';
    if (key == "privacy_explain") {
      title = "隐私声明";
    } else if (key == "disclaimer") {
      title = "免责声明";
    } else if (key == "card_explain") {
      title = "志愿卡说明";
    } else if (key == "instructions") {
      title = "使用说明";
    } else if (key == "user_agreement") {
      title = "用户协议";
    }
    let postdata = {
      key,
    };
    let [datas] = await Promise.all([
      await app.$axios.$post(
        "/app/artapi.php?r=getconfig.get_config_value",
        postdata
      ),
    ]);
    datas = datas ? datas.data : [];
    return {
      datas,
      title
    };
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
    },
  },
};
